module.exports = __webpack_public_path__ + "static/sieben-stadte-der-liebe-03-8c160a56fd1b9cd47106ff2efc1106a0.jpg";